// @ts-nocheck
import { OverflowWrapperProps } from "@insite/mobius/Popover/Popover";
import { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

const focusedStyles = (widthToUse: number, isAuthenticated: boolean) => ({
    css: css`
        position: absolute;

        max-width: ${widthToUse}px;

        @media (min-width: 900px) and (max-width: 1350px) {
            left: ${isAuthenticated ? "22%" : "30%"};
            max-width: ${widthToUse + 30}px;
        }
        @media (min-width: 600px) and (max-width: 900px) {
            left: 50%;
            max-width: 100%;
        }

        top: ${pxToRem(22)};
        transform: translate(-50%, -50%);
        width: 500% !important;
        left: 33%;
        will-change: transform;
        transition: max-width 0.3s ease, transform 0.3s ease, translate 0.3s ease;
    `,
});

const unfocusedStyles = {
    css: css`
        left: 50%;

        top: ${pxToRem(22)};

        width: 500% !important;
        max-width: 100%;
        transform: translate(-50%, -50%);
        position: absolute;
        transition: max-width 0.3s ease, transform 0.3s ease, translate 0.3s ease;
        will-change: transform;
    `,
};

export const getOverFlowWrapperProps = (
    isFocused: boolean,
    widthToUse: number,
    isAuthenticated: boolean,
    handleBlur: () => void,
    handleFocus: () => void,
    popoverWrapperCss?: StyledProp<{}> | undefined,
): OverflowWrapperProps => {
    const overFlowWrapperStyles = isFocused ? focusedStyles(widthToUse, isAuthenticated) : unfocusedStyles;

    const overFlowWrapperProps: OverflowWrapperProps = {
        onBlur: handleBlur,
        onFocus: handleFocus,
        css: css`
            ${popoverWrapperCss}

            ${overFlowWrapperStyles.css}
            z-index: 5;
        `,
    };

    return overFlowWrapperProps;
};
